<nav class="navbar navbar-inverse">
  <div class="navbar-header">
    <a class="navbar-brand"> Mark-List </a>
  </div>
</nav>

<div class="container">
  <div class="card-inter overflow-hidden">
    <div class="row">
      <div class="col-md-8">
        <h2 class="border-top">Registros</h2>
      </div>
      <div class="col-md-4" *ngIf="!mostrarbtn">
        <button
          authorizedElement
          [authElementCode]="19502"
          [authElementName]="'BTN_MARK_LIST_ADD_PERSON'"
          class="btn btn-md btn-info pull-right"
          (click)="incomeForm()"
          data-toggle="modal">
          Ingresar persona
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-info pull-right" (click)="generateExcel()" [disabled]="loadExcelReport">
          <span *ngIf="!loadExcelReport" class="">
            {{ "consultaMarkList_component_loadExecutionProcessFile_GENERATE" | i18n }}
          </span>
          <div [hidden]="!loadExcelReport">
            <img src="assets/img/loading-gif.gif" alt="Cargando"  width="20px" height="20px">
            {{ "consultaMarkList_component_loadExecutionProcessFile_DOWNLOADING" | i18n }}
            {{progressPercent ? progressPercent + '%' : ''}}
          </div>
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <generic-table-avla
          #tableComponent3
          [tableName]="'markListTable'"
          [editableRow]="false"
          [enableGeneralSearch]="false"
          [urlData]="'/api-mark-list/personListPaginated'"
          [showSelectorRowsOnPage]="false"
          [showReloadButton]="false"
          [serverPagination]="true"
          [deletableRow]="false"
          [columns]="columnsTable3"
          [sortBy]="sortBy"
          [sortOrder]="sortOrder"
          [textTableEmpty]="
            'No se encuentra cliente. Por favor presione el boton ingresar para ingresar un nuevo cliente a Mark-List'
          "
          [showFilterByColumn]="true"
          [primaryIndexer]="primaryIndexerTable3"
          [templateColumns]="{
            ver: verTemplate
          }">
        </generic-table-avla>
      </div>
    </div>
  </div>
</div>

<ng-template
  #verTemplate
  let-item="item"
  let-col="col"
  let-cellValue="cellValue">
  <!-- este es el boton que abre en detalle las personas, q tambien me permite agregarlas -->
  <button
    type="button"
    id="{{ cellValue }}"
    (click)="openModal(item)"
    class="btn btn-info btn-xs">
    <i class="glyphicon glyphicon-eye-open"></i>
  </button>
</ng-template>

<panel-modal
  size="xl"
  title="{{ 'Datos personales' | i18n }}"
  [(close)]="modal.modalSwitchClose"
  [(open)]="modal.modalSwitchOpen"
  [templateBody]="templateModal"
  [detail]="true">
</panel-modal>
<ng-template #templateModal>
  <app-ml-modal
    (changeStatus)="closeModal($event)"
    (reloadModal)="refresh($event)"></app-ml-modal>
</ng-template>

<panel-modal
  title="{{ 'Ingrese los datos del registro' | i18n }}"
  classBody="width-50"
  [(open)]="modal.createPersonSwitchOpen"
  [(close)]="modal.createPersonSwitchClose"
  [templateBody]="templateNoModal"
  [detail]="true">
</panel-modal>
<ng-template #templateNoModal>
  <app-ml-form-dinamic
    (registroExitoso)="onCloseIncomeForm()"></app-ml-form-dinamic>
</ng-template>
